export default function CallIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.1861 13.4686L15.1473 12.3705C14.6509 12.1032 14.2649 12.2966 13.8374 12.8843C12.8988 14.1749 12.4434 14.4298 11.2916 13.7872C10.2168 13.1876 9.44718 12.4754 8.48186 11.5108C7.51661 10.5462 6.80381 9.77726 6.20373 8.70322C5.56065 7.55226 5.8158 7.0973 7.10734 6.15938C7.69554 5.73222 7.88902 5.34655 7.62153 4.85051L6.52256 2.8133C6.0735 1.94684 5.43664 1.84792 4.49483 2.16634C3.19579 2.6055 1.93857 4.48009 2.00233 5.3698C2.18868 7.96939 3.49126 11.0928 6.20206 13.8012C8.91265 16.5099 12.0384 17.8116 14.6401 17.9977C15.5304 18.0615 17.394 16.7927 17.8336 15.4946C18.1522 14.5537 18.0531 13.9173 17.1861 13.4686Z"
        fill="#6C6969"
      />
      <path
        d="M11.0183 5.89697C10.6157 5.90029 10.2921 6.22932 10.2954 6.63178C10.2987 7.03225 10.6245 7.35471 11.024 7.35471C11.0309 7.35424 11.0378 7.35471 11.0439 7.35471C11.4776 7.35471 11.8839 7.52221 12.1892 7.82728C12.4976 8.13572 12.6654 8.5474 12.6618 8.98607C12.6585 9.38846 12.9821 9.71756 13.3847 9.72088H13.3909C13.7905 9.72088 14.1162 9.39842 14.1195 8.99795C14.1264 8.16541 13.8068 7.38361 13.2199 6.79662C12.6331 6.20963 11.8394 5.90193 11.0183 5.89697Z"
        fill="#6C6969"
      />
      <path
        d="M15.3694 4.64685C14.2085 3.48568 12.6447 2.84747 11.0216 2.85579C10.619 2.8572 10.2939 3.18462 10.2954 3.58724C10.2968 3.98896 10.6228 4.31353 11.0242 4.31353C11.0288 4.31279 11.0373 4.31329 11.0441 4.31353C12.289 4.31353 13.4588 4.79755 14.3388 5.67751C15.2225 6.5613 15.707 7.73736 15.7027 8.98919C15.7013 9.39181 16.0266 9.71927 16.429 9.72068H16.4316C16.833 9.72068 17.1591 9.39611 17.1605 8.99443C17.1662 7.35114 16.5301 5.80704 15.3694 4.64685Z"
        fill="#6C6969"
      />
    </svg>
  );
}
